import { render, staticRenderFns } from "./writePost.vue?vue&type=template&id=83fd1772&"
import script from "./writePost.vue?vue&type=script&lang=js&"
export * from "./writePost.vue?vue&type=script&lang=js&"
import style0 from "./writePost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports